<template>
  <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
              <b-card header-tag="header" footer-tag="footer">
                  <div slot="header">
                      <strong> In Scan Out Scan </strong> 
                  </div>
                
                  <div>
                      <b-row>
                          <b-col md="10">
                              <b-row>
                                  <b-col>
                                    <b-form-group label="From Date:" :label-cols="4">
                                      <v-date-picker
                                        mode="single"
                                        input-class="dateInput"
                                        :available-dates="fromDateRange"
                                        v-model="selectDateFrom"
                                        @input="onFromDateChange"
                                      />
                                    </b-form-group>
                                  </b-col>

                                  <b-col>
                                    <b-form-group label="To Date:" :label-cols="3">
                                      <v-date-picker
                                        mode="single"
                                        input-class="dateInput"
                                        :available-dates="toDateRange"
                                        v-model="selectDateTo"
                                      />
                                    </b-form-group>
                                  </b-col>
                                  
                                  <b-col>
                                      <b-form-group label="Select Hub"
                                      :label-cols="4">
                                          <b-form-select  v-model="selectedhub">
                                              <option :value="select">-- Select Hub --</option>
                                              <option :value="hub.hubid" v-for="hub in hubItems"  :key="hub.hubid" >
                                                  {{hub.hubname}} - {{hub.hubid}}
                                              </option>
                                              
                                          </b-form-select>
                                      </b-form-group>
                                  </b-col>
                              </b-row>            
                          </b-col>

                          <b-col md="10">
                            <b-form-group label="Selected Date : " :label-cols="2">
                              <b-form-radio-group v-model="selected_date" class="mt-1">
                                <b-form-radio value="dispatch_date">Dispatch Date</b-form-radio>
                                <b-form-radio value="hubinscan_date">Hubinscan Date</b-form-radio>
                                <b-form-radio value="dispatchoutscan_date">Dispatch Out Scan Date</b-form-radio>
                                <b-form-radio value="zoneinscan_date">Zone inscan Date</b-form-radio>
                              </b-form-radio-group>
                            </b-form-group>
                          </b-col>

                          <b-col md="3" class="pr-0">
                            <b-form-group label="Status" :label-cols="3">
                              <b-form-select  v-model="selected_status">
                                <option :value="select_st">-- Select Status --</option>
                                <!-- <option :value="status.shipmentstatus" v-for="status in statusitem"  :key="status.shipmentstatus" >
                                {{status.shipmentstatus}}
                              </option> -->
                              <option value="Delivered">Delivered</option>
                              <option value="DispatchOutScan">Dispatch Out Scan</option>
                              <option value="INTransit">INTransit</option>
                              <option value="OFD">OFD</option>
                              <option value="ZoneInScan">Zone In Scan</option>
                              <option value="HubInScan">Hub In Scan</option>
                              <option value="ZoneOutScan">Zone Out Scan </option>
                              <option value="NDR">NDR</option>
                              
                               
                               </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group label="Select Vehicle"  :label-cols="4" >
                    
                              <v-select v-model="selectvehicleid" @input="Select_vehicletype(selectvehicleid)" :options="vehicle_items" placeholder="--Select Vehicle--"></v-select>
                             
                            </b-form-group>
                          </b-col>

                          <b-col md="2" class="pr-0 pl-0">
                              <b-button :disabled="selectedhub.length == 0 && selectDateFrom.length==0 && selectDateTo.length==0" @click="searchhub(pageNum)"  size="md" variant="primary">Search</b-button>
                              &nbsp;
                              <b-button :disabled="selectedhub.length == 0 && selectDateFrom.length==0 && selectDateTo.length==0" @click="clearSearch()"    size="md" variant="danger">Clear</b-button>
                          </b-col>
                          <b-col md="3" class="pl-0">
                            <b-row class="p-0">
                               <b-col md="3" class="pl-0" v-if="totalRows>0">
                                <div v-if="selected_status && !selectvehicleid">
                                  <b-button
                                    v-b-tooltip.hover
                                    title="Download Reports"
                                    variant="primary"
                                    :disabled="totalRows == 0"
                                    @click="handleDownloadRequest"
                                  >
                                    Download
                                  </b-button>
                                </div>

                                <div v-if="selectvehicleid && !selected_status">
                                    <b-button
                                    v-b-tooltip.hover
                                    title="Download Reports"
                                    variant="primary"
                                    :disabled="totalRows == 0"
                                    @click="handleDownloadRequest"
                                  >
                                    Download
                                  </b-button>
                                </div>
                                <div v-if="selectvehicleid && selected_status">
                                      <b-button
                                    v-b-tooltip.hover
                                    title="Download Reports"
                                    variant="primary"
                                    :disabled="totalRows == 0"
                                    @click="handleDownloadRequest"
                                  >
                                    Download
                                  </b-button>
                                  
                                </div>


    
                                <div  v-if="!selectvehicleid && !selected_status">
                                  <b-button
                                    v-b-tooltip.hover
                                    title="Download Reports"
                                    variant="primary"
                                    :disabled="totalRows == 0"
                                    @click="handleDownloadRequest"
                                  >
                                    Download
                                  </b-button>
                                </div>

                              </b-col> 
                             
                             
                             



                              <!-- v-if="SysUser=='18'||SysUser=='34'||SysUser=='465'||SysUser=='108'||SysUser=='143'||SysUser=='55'" -->
                              <b-col md="9" class="pr-0 pl-0" >
                                &nbsp;
                                <b-button variant="primary" size="md" class="ml-3"
                                  v-if="totalRows>0" :disabled="isBusyDownload"
                                  @click="downlaodloadurl">
                                  {{ isBusyDownload ? 'Preparing download...' : 'Load Wise journey Report' }}
                                </b-button>

                                 <a :href="loadurl" target="_blank" class="ml-3" v-if="totalRows>0">
                                  <b-button variant="danger"  size="md" @click="downlaodloadurlNew"> journey  Report</b-button>
                                </a>
                              </b-col>
                            </b-row>
                          </b-col>
                      </b-row>
                  </div>
                  
                  <b-row>
                  <b-col class="text-right">
                    <b-button
                      type="submit"
                      variant="primary"
                      size="md"
                      @click="reportListing"
                    >
                      Report Status
                    </b-button>
                  </b-col>
                </b-row>
               <div  v-if="isBusyDownload" class="text-center">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Being Prepared for Download ...</strong>
                  </div>

                  <div class="text-right mt-3">
                      <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
                  </div>

                  <b-row>
                      <b-col md="12">
                          <b-table show-empty responsive  :items="hubscanlist"  :fields="fields"    :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy"> 

                              <div slot="table-busy" class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>Loading...</strong>
                              </div> 
                              <template slot="loadid" slot-scope="row">
                                  {{row.item.loadid}}
                                  <br>
                                  <br>
                                    <span v-if="row.item.defective_boxes>0 " class="badge " style="background-color:rgb(235 113 100);color:white;font-size: 13px;padding:6px;padding-top: 4px;"   >Defective Count :  {{ row.item.defective_boxes }}</span>
                                  </template> 
                              
                              <template slot="noofboxes" slot-scope="row">
                                  <button v-b-tooltip.hover title="View Count Details" @click="BoxDetails(row.item)" style="background-color:white !important;" class="btn btn-link" >
                                        <span style="color:#1b8eb7"> {{row.item.noofboxes}} </span>
                                  </button>
                              </template> 
                            </b-table>  
                      </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" v-if="totalRows>0">
                      <!--<paginate :page-count="noofpages" :page-range="10"
                      :margin-pages="2" :click-handler="clickCallback"
                      :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"
                      :page-class="'page-item'"></paginate>  -->
                       <b-pagination
                  v-if="totalCount > perPage"
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  @change="clickCallback"
                ></b-pagination>
                    </b-col>
                  </b-row>
                  <b-modal size="lg" title="MPS Count Details" v-model="boxdetailsmodal" @ok="boxdetailsmodal = false" hide-footer>
      
                      <template slot="default" slot-scope="{ hide }">
                      <b-row>
                      <b-col sm="12" class="text-right">
                        <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                      </b-col>   
                      <div style="float: left;">
                          <!-- v-if="this.mpstotalRows > 0" -->
                          <span class="badge ml-2" 
                          style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 5px 5px 5px;">DB</span> Damage Box&nbsp;&nbsp;
                        </div>
                      <b-col sm="12"> 
                        <!-- <b-col sm="12"> -->
                      <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyMps" >
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div> 
                          <template slot="shippingid" slot-scope="row">
                              <span>{{row.item.shippingid}}</span>
                              <br>
                              <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 13px;padding:6px;padding-top: 4px;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                            </template> 
                        <template slot="mpsvalue" slot-scope="row">
                                <span>{{row.item.mpsvalue}}</span>
                              </template>
                              <template slot="physicalweight" slot-scope="row">
                                <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                              </template>
                              <template slot="breadth" slot-scope="row">
                                <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                              </template>
                              <template slot="length" slot-scope="row">
                                <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                              </template>
                              <template slot="height" slot-scope="row">
                                <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                              </template>
                              <template slot="deliverystatus" slot-scope="row">
                                <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;"> {{row.item.deliverystatus}} </span>
                                <span v-else> {{row.item.deliverystatus}} </span>
                              </template>
                              <template slot="shipmentstatus" slot-scope="row">
                                <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;">{{row.item.shipmentstatus}} </span>
                                <span v-else>{{row.item.shipmentstatus}}</span>
                              </template>
                            
                      </b-table> 
                    <!-- </b-col> -->
                    </b-col>
                    </b-row> 
                      <b-row>
                      <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                        <b-pagination
                              v-model="mpscurrentPage"
                              :total-rows="mpstotalRows"
                              :per-page="mpsperPage"
                              class="my-0"
                            ></b-pagination>
                    
                      </b-col> 
                    </b-row>
                        <div class="col-md-12 pull-right"> 
                                <div slot="footer" class="text-right">
                                
                                  <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                                </div>
                              </div>
                      </template>
                      <template slot="modal-footer" slot-scope="{ cancel }">
                        <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
                          Cancel
                        </b-button>
                      </template>
                  </b-modal>

                  <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
                      <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
                        No Record Found
                      </div>
                      <div v-else class="text-center">
                        <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
                      </div>
                    </b-modal>
                    
                <b-modal
                  v-model="listingmodal"
                  title="Reports"
                  @ok="listingmodal = false"
                  @cancel="listingmodal = false"
                  size="xl"
                >
                  <b-table show-empty :items="listing" :fields="reportTableFiels">
                    <template slot="sn" slot-scope="data">
                      {{ data.index + 1 }}
                    </template>
                    <template slot="status" slot-scope="row">
                      <b-badge
                                        :variant="getStatusVariant(row.item.status)"
                                        class="mr-2"
                                        aria-disabled="true"
                                        style="pointer-events: none; opacity: 0.65; font-size: 0.75rem; padding: 0.35em 0.75em;"
                                      >
                                        {{ row.item.status }}
                                      </b-badge>
                                  </template>
                                  <template slot="download_url" slot-scope="row">
                                <b-link
                                  v-if="row.item.download_url"
                                  @click="downloadFile(row.item.download_url)"
                                  style="cursor: pointer;"
                                >
                                  <i class="fa fa-download" aria-hidden="true"></i>
                                </b-link>
                                <span v-else>-</span>
                              </template>
                  </b-table>
                </b-modal>

              </b-card>
          </b-col>
      </b-row>
  </div>

</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import Swal from 'sweetalert2';
export default {
  data() {
      return {
          hubscanlist :[],
          fields : [
              { key : 'parentawb', label :'Parent AWB', sortable: true},
              { key : 'loadid', label :'Load ID', sortable: true},
              { key: 'accounttype', label: 'Account Type',sortable: true, sortDirection: 'desc' },
              { key : 'zoneinscandate', label :'Zone In Scan Date', sortable: true},
              { key : 'zoneoutscandate', label :'Zone Out Scan Date', sortable: true},
              { key : 'noofboxes', label :'NO. Of Boxes', sortable: true},
              { key : 'origin_city', label :'Origin City', sortable: true},
              { key : 'dest_city', label :'Destination City', sortable: true},
              { key : 'loadstatus', label :'Load Status', sortable: true},
              { key : 'dispatch_vehicle', label :'Dispatch Vehicle', sortable: true},
              { key : 'inward_vehicle', label :'Inward Vehicle', sortable: true},
              { key: 'assigned_vehicle', label: 'Assigned Vehicle', sortable: true, sortDirection: 'desc'},
              { key: 'calulatededd', label: 'EDD', sortable: true}
          ],
          totalRows :0,
          mpsitems:[],
          mpstotalRows :'',
          mpsfields:[
              { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
              { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
              
              { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
              { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
              
              { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
              { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
              { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
              { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
              { key: 'assigned_vehicle', label: 'Assigned Vehicle', sortable: true, sortDirection: 'desc'},
              { key: 'calulatededd', label: 'EDD', sortable: true}
          ],
          isBusy : false,
          isBusyDownload: false,
          downlaodScanurl :'',
          UserName:'',
          SysUser :'',
          Userhubid:'',
          boxdetailsmodal :false,
          // selectDateFrom :'',
          // selectDateTo :'',
          selectDateFrom: new Date(),
          fromDateRange: null, // optional restriction
          toDateRange: null,
          selectDateTo:new Date(),
          isBusyMps:false,
          mpstotalRows: 0,
          mpscurrentPage: 1,
          mpsperPage: 10,
          hubItems:[],
          selectedhub:'',
          select :'',
          selectedhubvalue :'',
          fromatstartdate :'',
          formatenddateto :'',
          selected_user_details :'',
          selected_date :'dispatch_date', 
          selected_status :'',
          select_st :'',
          statusitem :[],
          statusObj:{},
          route_id:null,
          noofpages:'',
          pageNum:1,
          listingpageno:1,
          totalCount: 0, 
          currentPage: 1,
          perPage:  50,
          vehicleitems :[],
          vehicle_items :[],
          selectvehicleid :'',
          loadurl:'',
          reportTableFiels: [
           { key: 'sn', label: 'S.No.' },
           { key: 'report_type', label: 'Report Type'},
           { key: 'created_date', label: 'Created At'},
           { key: 'status', label: 'Status'},
           { key: 'remarks', label: 'Action' },
           { key: 'download_url', label: 'Download'}    
          ],
          listingmodal: false,
          listing: [],
      }
  },
  created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // console.log("userInfo",userInfo)
      this.UserName= userInfo.user_type;
      this.SysUser= userInfo.sysusermasterid;
      this.Userhubid = userInfo.hub_id;
      this.route_id = this.$route.params.id;
    console.log("this.route_id",this.route_id)
      const INScanOutScanurl = `${CONSTANTS.MIGRATION_API_URL}/getCSVForInscanOutscanShipmentThroughSchedular?`
      this.downlaodScanurl=INScanOutScanurl;
      console.log(" this.downlaodScanurl", this.downlaodScanurl)
      this.hubListing();
      this.displaydata();
      this.getscandetailsList(this.pageNum);

      
  },
  computed: {
    // From Date: allow till today
    fromDateRange() {
      return {
        start: null,
        end: new Date(),
      };
    },

    // To Date: max 100 days from From Date
    toDateRange() {
      if (!this.selectDateFrom) {
        return { start: null, end: null };
      }

      const start = new Date(this.selectDateFrom);
      const end = new Date(this.selectDateFrom);
      end.setDate(end.getDate() + 100);

      return {
        start,
        end,
      };
    },
  },
  mounted() {
    this.onFromDateChange();
  },
  methods: {
    onFromDateChange() {
        if (!this.selectDateFrom) return;

        const from = new Date(this.selectDateFrom);

        // allow only 1 month range
        const maxDate = new Date(from);
        maxDate.setMonth(maxDate.getMonth() + 1);

        // 🚀 Restrict "To Date" picker
        this.toDateRange = {
          start: from,
          end: maxDate
        };

        // 🚀 Auto-fix To Date if invalid
        if (
          this.selectDateTo &&
          new Date(this.selectDateTo) > maxDate
        ) {
          this.selectDateTo = maxDate;
        }

        // 🚀 Also prevent To < From
        if (
          this.selectDateTo &&
          new Date(this.selectDateTo) < from
        ) {
          this.selectDateTo = from;
        }
    },
  
    downloadReport() {
           let url = this.downlaodScanurl + 
              'usertype=' + this.UserName + 
              '&sysusermasterid=' + this.SysUser + 
              '&hub_id=' + this.selectedhub + 
              '&startdate=' + this.fromatstartdate + 
              '&enddate=' + this.formatenddateto + 
              '&date_category=' + this.selected_date + 
              '&&is_asn=' + (this.route_id === 'normal' ? 'NO' : 'YES');

        if (this.selectvehicleid) {
          const vehicleId = this.selectvehicleid ? this.selectvehicleid.split('-')[1] : '';
          url += `&vehicle_id=${vehicleId}`;
        }

        if (this.selected_status) {
          url += `&status=${this.selected_status}`;
        }

        // Show confirmation popup
        this.$bvModal.msgBoxConfirm('Do you want to download the report?', {
          title: 'Download Confirmation',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(confirmed => {
          if (confirmed) {
           // Trigger the download
           const newWindow = window.open(url, '_blank');

            // Check if the download was successful
            if (newWindow) {
              this.$fire({
                text: "Download started successfully!",
                type: "success",
                timer: 5000
              });
            } else {
              this.$fire({
                text: "Unable to download the report.",
                type: "error",
                timer: 30000
              });
            }
          }
        }).catch(err => {
          console.error(err);
        });
      },

      downlaodloadurl(){
        const userInfo = JSON.parse(localStorage.getItem("userData"));
        const params = new URLSearchParams({
          sysusermasterid: userInfo.sysusermasterid,
          usertype: userInfo.user_type,
          startdate: this.fromatstartdate,
          enddate: this.formatenddateto,
          date_category: this.selected_date,
          hub_id: this.selectedhub || '',
          is_asn: this.route_id === 'normal' ? 'NO' : 'YES'
        });
        const url = `${CONSTANTS.MIGRATION_API_URL}/getCSVForHubJourney?${params.toString()}`;
        this.isBusyDownload = true;

        this.$http.get(url, { responseType: 'blob' }).then(result => {
          const blob = result.body instanceof Blob ? result.body : new Blob([result.body], { type: 'text/csv' });
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = 'HubJourney.csv';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);

          this.$fire({ text: 'Download completed successfully!', type: 'success', timer: 5000 });
        }).catch(error => {
          console.error('getCSVForHubJourney download failed:', error);
          this.$fire({ text: 'Unable to download the report.', type: 'error', timer: 10000 });
        }).finally(() => {
          this.isBusyDownload = false;
        });
      },
        downlaodloadurlNew(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        
        this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForJourneyColumnwise?sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`startdate=`+this.fromatstartdate+`&&`+`enddate=`+this.formatenddateto+`&&`+`date_category=`+this.selected_date+`&&`+`hub_id=`+this.selectedhub+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')

        console.log("this.loadurl",this.loadurl)
      },

      displaydata: function() {
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          const deliveryagentobj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`,
            isactive:'1',
            vehicle_type: "bulkreallocate"
          };
          console.log('deliveryagentobj',deliveryagentobj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
              deliveryagentobj)
            .then(result => {
              console.log("YYY",result);
              if (result.body.length > 0) {
                this.vehicleitems  = result.body;
                for (let i = 0; i <  this.vehicleitems.length; i++) {
                  var vehicle_idDetails =  this.vehicleitems[i].vehicle_no + "-" +  this.vehicleitems[i].vehicle_id;
                  this.vehicle_items.push(vehicle_idDetails)
                }
                console.log("okkkk",this.vehicle_items)
              
              } else {
                this.vehicleitems  = result.body;
                
              }
            })
            .catch(ex => {
              console.log("error", ex);
            });
        
        },
    
        clickCallback (pageNum = this.currentPage){
            this.getscandetailsList(pageNum);
        },
        getscandetailsList :function(pageNo){
          this.isBusy=true;
          this.hubscanlist=[];
          this.totalRows=0;
          this.currentPage = pageNo;

          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          var starttoday = this.selectDateFrom;
          // Current Date
          this.fromatstartdate = starttoday.getFullYear()+'-'+(starttoday.getMonth()+1)+'-'+starttoday.getDate();
          console.log("startdate",this.fromatstartdate);

          var endtoday = this.selectDateTo;
          // End Date
          this.formatenddateto = endtoday.getFullYear()+'-'+(endtoday.getMonth()+1)+'-'+endtoday.getDate();
         
          console.log("this.selectvehicleid",this.selectvehicleid.split("-")[1])

        if(this.selected_status!=''){
          this.statusObj={
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`,
              hub_id:`${this.selectedhub}`,   
              startdate: `${this.fromatstartdate}`,
              enddate:`${this.formatenddateto}`,
              date_category : `${this.selected_date}`,
              status : `${this.selected_status}`,
              is_asn: this.route_id=='normal' ? 'NO': 'YES',
              page_no:`${pageNo}`,
              vehicle_id:this.selectvehicleid==undefined?"":this.selectvehicleid.split("-")[1]
          }
        }else{
          this.statusObj={
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`,
              hub_id:`${this.selectedhub}`,   
              startdate: `${this.fromatstartdate}`,
              enddate:`${this.formatenddateto}`,
              date_category : `${this.selected_date}`,
              is_asn: this.route_id=='normal' ? 'NO': 'YES',
              page_no:`${pageNo}`,
              vehicle_id:this.selectvehicleid==undefined?"":this.selectvehicleid.split("-")[1]
          }
        }
          let obj=this.statusObj;
          console.log("ibject",obj)
          // return false
          this.$http
              .post(
                  `${ CONSTANTS.MIGRATION_API_URL}/getHubInScanOutscanDetailReport`,obj).then(result => {
                    // alert("innn");
                  this.isBusy=false;
                  if (result.body.returnmsg === "Successful") {
                  this.hubscanlist=result.body.returnvalue;
                  this.totalCount = result.body.returnvalue[0].totalloadcount;
                  this.totalRows=result.body.returnvalue[0].totalloadcount;
                 // this.noofpages=parseInt(this.totalRows)/50;
                 // this.noofpages=Math.ceil( this.noofpages);
                  }else{
                      this.hubscanlist=[];
                      this.totalRows=0;
                      this.totalCount =0;
                  }
                  }).catch(ex => {
                  console.log("error", ex);
              });
      },


      hubListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj={
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype : `${userInfo.user_type}`,
      }
      console.log("objlist",obj)
      this.$http
            .post(
              `${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj).then(result => {
                if (result.body.returnmsg === "Successful") {
                 this.hubItems=result.body.returnvalue;
                 console.log("aaaaaaaa",this.hubItems);
                 
                }else{
                  this.hubItems=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
      },

      searchhub (pageNum){
        // console.log("Hub",pageNum)
          let userData = localStorage.getItem('userData');
          let userInfo = JSON.parse(userData);
          this.selectedhub=this.selectedhub;
          // console.log("sssssss",this.selectedhub)
          this.getscandetailsList(pageNum);
      },
      clearSearch(){
          this.selectedhub ='';
          this.selected_status = '';
          this.selected_date = 'dispatch_date';
          this.selectDateFrom= new Date();
          this.selectDateTo=new Date();
          this.selectvehicleid="";
          this.getscandetailsList(this.pageNum);

      },
       // open models

      BoxDetails:function(value){
          this.mpscurrentPage=1;
          this.boxdetailsmodal=true;
          this.isBusyMps = true;
          let userData = localStorage.getItem('userData');
          let userInfo = JSON.parse(userData);
  
          let obj = {
              parentawb: value.parentawb,
          }
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
              .then(result => {
                  this.isBusyMps = false;
                  if(result.body.returnmsg === "successful"){
                  
                  this.mpsitems  = result.body.returnvalue;
                  this.mpstotalRows = result.body.returnvalue.length;
                  
                  }else {
                  this.mpsitems  = [];
                  this.mpstotalRows = 0
                  }
              }).catch(ex => {
              console.log('error', ex)
          })
          
      },

      detailsCancel : function () {
          this.boxdetailsmodal=false;
      },

      Viewimagedetails : function (data){
          this.selected_user_details=data;
          console.log("rrrrrrrrrrr",this.selected_user_details);
      },

      statusListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj={}
      console.log("objlist",obj)
      this.$http
            .post(
              `${ CONSTANTS.MIGRATION_API_URL}/getDistinctShipmentStatus`,obj).then(result => {
                if (result.body.returnmsg === "Successful") {
                 this.statusitem=result.body.returnvalue;
                 console.log("aaaaaaaa",this.statusitem);
                 
                }else{
                  this.statusitem=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
      },
       
       
    reportListing: function() {

      var userdata = localStorage.getItem('userData');
      var userInfo = JSON.parse(userdata);
      
      this.listingmodal = true;
       var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            report_type: 'HubInscanOutscanReport'
           }; 

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getReportQueue`, csvObj)
          .then(result => {
            console.log("result", result);

            if(result.body.returnmsg === 'Successful'){
              this.listing = result.body.returnvalue;
              console.log("listing", this.listing);
            }

          
          })
          .catch(ex => {
            console.log("error-----", ex);
          });

          

    },
    getStatusVariant: function(status) {
      switch (status) {
        case 'success':
          return 'success'; // green
        case 'failed':
          return 'danger';  // red
        case 'pending':
          return 'warning'; // yellow
        default:
          return 'secondary'; // grey fallback
      }
    },
  downloadFile: function(url) {
      if (!url) {
        this.$bvToast.toast('No download URL available.', {
          title: 'Download Error',
          variant: 'warning',
          solid: true,
        });
        return;
      }
      window.open(JSON.parse(url), '_blank');
    },
        
    handleDownloadRequest() {
  // Calculate date difference in days
  const start = new Date(this.selectDateFrom);
  const end = new Date(this.selectDateTo);
  const diffDays = (end - start) / (1000 * 60 * 60 * 24);

  // Prepare query params
  let params =
    `usertype=${this.UserName}` +
    `&sysusermasterid=${this.SysUser}` +
    `&hub_id=${this.selectedhub}` +
    `&startdate=${this.fromatstartdate}` +
    `&enddate=${this.formatenddateto}` +
    `&date_category=${this.selected_date}` +
    `&is_asn=${this.route_id == 'normal' ? 'NO' : 'YES'}` +
    (this.selected_status ? `&status=${this.selected_status}` : '') +
    (this.selectvehicleid ? `&vehicle_id=${this.selectvehicleid.split('-')[1]}` : '');

  if (diffDays <= 151) {
    // Direct download via GET
    const url = `${CONSTANTS.MIGRATION_API_URL}/getCSVForInscanOutscanShipment?${params}`;
    window.open(url, '_blank');
  } else {
    // Queue download
    this.isBusyDownload = true;
    const schedularUrl = `${CONSTANTS.MIGRATION_API_URL}/getCSVForInscanOutscanShipmentThroughSchedular?${params}`;
    this.$http.get(schedularUrl)
      .then(result => {
      this.isBusyDownload = false;
        if (
          result.body &&
          result.body.returnmsg === "Successful"
        ) {
          Swal.fire(
            'Queued',
            'Report download added in queue.<br>Status: <b>Pending</b>',
            'info'
          );
        } else {
          Swal.fire(
            'Error',
            'Failed to queue download request.',
            'error'
          );
        }
      })
      .catch(() => {
      this.isBusyDownload = false;
        Swal.fire('Error', 'Failed to queue download request.', 'error');
      });
  }
},
      Select_vehicletype(data){
        if (data==null) {
          this.selectvehicleid="";
          this.getscandetailsList(this.pageNum);
          console.log("pppppp")
        }
      }

  },
}
</script>

<style>

</style>
